import React from 'react';
import avatar from '../../assests/logo.png';
import moment from 'moment';

const Sidebar = ({ sidebarData, selectedTeacher, setSelectedTeacher }) => {
  return sidebarData.length
    ? sidebarData.map((item, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                setSelectedTeacher({
                  ...item,
                  id: item.teacherId,
                });
              }}
              className={`chat-list-item ${selectedTeacher && item.teacherId == selectedTeacher.id ? 'selected' : ''}`}
            >
              <img src={(item && item.avatar) || avatar} alt="avatar" className="chat-avatar" />
              <div className="chat-info">
                <h2 className="chat-user-name">
                  {item.first_name} {item.middle_name} {item.last_name}
                </h2>
                <p className="chat-message-preview mb-0">{item.content.substring(0, 30) || item.signedUrl}...</p>
                <p className="chat-timestamp mb-0">{moment(item.created_at).fromNow()}</p>
              </div>
            </div>
          </div>
        );
      })
    : null;
};

export default Sidebar;
